const initialProductsState = {
  showId: null,
  showName: null,
  products: [],
  performance: null,
  date: null,
  paxs: 2,
  orderOption: null,
  reservationType: null,
  callCenter: null,
  availabilityRefId: null,
  dateRange: [
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ],
  imageUrl: null,
  hasTransportation: false,
  transfer: null,
  totalAmount: null,
  specialRequests: '',
  sellerDiscount: null,
  voucherCode: null,
  attribute:'default',
};

export default (state = initialProductsState, action) => {
  switch (action.type) {
    case 'RESET_RESERVATION':
      return initialProductsState;

    case 'SET_RESERVATION_TYPE':
      return {
        ...state,
        reservationType: action.payload,
      };

    case 'RESERVATION_INFO': {
      return {
        ...state,
        showId: action.payload.showId,
        showName: action.payload.showName,
        products: action.payload.products ? action.payload.products : [],
        performance: action.payload.performance ? action.payload.performance : state.performance,
        date: action.payload.date,
        paxs: action.payload.paxs ? action.payload.paxs : state.paxs,
        callCenter: action.payload.callCenter,
        availabilityRefId: action.payload.availabilityRefId,
        imageUrl: action.payload.imageUrl,
        hasTransportation: action.payload.hasTransportation,
        transfer: action.payload.transfer || state.transfer,
        totalAmount: action.payload.totalAmount,
        specialRequests: action.payload.specialRequests ?? state.specialRequests,
        calendar: action.payload.calendar,
        attribute: action.payload.attribute,
      };
    }

    case 'RESERVATION_EXTRA_PAX': {
      let newProducts = [...state.products];

      newProducts.forEach((item, i) => {
        newProducts[i].extraPaxs = 0;
      });

      action.payload.forEach((item, i) => {
        let index = newProducts.findIndex((p) => p.id === item.id);

        if (item.specialType === 'EXTRAPAX') {
          if (item.seatProps)
            index = newProducts.findIndex((p) => p.id === item.id && p.seats === item.seatProps.id);

          newProducts[index].extraPaxs += item.quantity;
        } else {
          if (index === -1 && item.quantity > 0) {
            newProducts.push({
              id: item.id,
              quantity: item.quantity,
              specialType: item.specialType,
            });
          } else if (index !== -1) {
            if (item.quantity === 0) newProducts.splice(index, 1);
            else newProducts[index].quantity = item.quantity;
          }
        }
      });

      return {
        ...state,
        products: newProducts,
      };
    }
    case 'SET_ORDER_OPTION': {
      return {
        ...state,
        orderOption: action.payload,
      };
    }
    case 'SET_DATE_RANGE': {
      return {
        ...state,
        dateRange: action.payload,
      };
    }
    case 'RESET_TRANSPORTATION':
      return {
        ...state,
        transfer: null,
        products: state.products.filter((product) => product.specialType !== 'TRANSFER'),
      };

    case 'SET_TRANSPORTATION': {
      return {
        ...state,
        transfer: action.payload,
      };
    }

    case 'UPDATE_TRANSFER_TRIPS': {
      return {
        ...state,
        transfer: {
          ...state.transfer,
          trips: action.payload,
        },
      };
    }

    case 'ADD_PRODUCT': {
      return {
        ...state,
        products: [...state.products, action.payload],
      };
    }

    case 'REMOVE_PRODUCT': {
      return {
        ...state,
        products: state.products.filter((product) => product.id !== action.payload.id),
      };
    }

    case 'SET_SELLER_DISCOUNT': {
      return {
        ...state,
        sellerDiscount: action.payload,
      };
    }

    case 'SET_VOUCHER_CODE': {
      return {
        ...state,
        voucherCode: action.payload,
      };
    }

    case 'RESET_VOUCHER_CODE': {
      return {
        ...state,
        voucherCode: null,
      };
    }

    default:
      return state;
  }
};
